var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{domProps:{"textContent":_vm._s(_vm.formatDate(_vm.issue.createdAt, 'dd/MM/yyyy HH:mm'))}})}
var staticRenderFns = []

export { render, staticRenderFns }